module.exports = __webpack_public_path__ + "static/media/sophia-baboolal-86224-unsplash.eb07f380.jpg";